// Splide JS

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';

// Marks a slider with .splide--many-pages whenever its pagination has more
// dots than PAGINATION_DOT_LIMIT, so CSS can hide the dots on mobile without
// hiding them on sliders short enough for dots to still be useful. Re-checked
// on every pagination rebuild since breakpoints change how many pages/dots
// a slider has.
var PAGINATION_DOT_LIMIT = 5;

function watchPaginationOverflow(splide) {
  function update(data) {
    var count = data && data.items ? data.items.length : 0;
    splide.root.classList.toggle('splide--many-pages', count > PAGINATION_DOT_LIMIT);
  }

  splide.on('pagination:mounted', update);
  splide.on('pagination:updated', update);
}

document.addEventListener( 'DOMContentLoaded', function() {
  var splideStats = document.querySelector('#logo-marquee');
  if(splideStats){
    new Splide( splideStats, {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 5,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: .25,
      },
      mediaQuery: 'max',
      breakpoints: {
        768: {
          perPage: 3,
          gap: '2rem',
        },
      },
     } ).mount( { AutoScroll } );
  } 
  
});

document.addEventListener( 'DOMContentLoaded', function() {
  // Splide for Team
  var splideTeam = document.querySelectorAll('.splide--team');

  if (splideTeam) {
    splideTeam.forEach(function(splide) {
      var slideCount = splide.querySelectorAll('.splide__slide').length;

      // perPage stays fixed to the grid tier sizes so a card always renders
      // at its normal "1 of 4/3/2" width instead of stretching to fill the
      // row. Only 'type' changes when there aren't enough real slides to
      // loop — 'loop' clones slides to fill perPage, which duplicates cards.
      var instance = new Splide(splide, {
        type: slideCount > 4 ? 'loop' : 'slide',
        perPage: 4,
        gap: '1.5rem',
        pagination: true,
        arrows: true,
        mediaQuery: 'max',
        breakpoints: {
          1200: {
            perPage: 3,
          },
          1024: {
            perPage: 2,
          },
          480: {
            perPage: 1,
          },
        },
      });
      watchPaginationOverflow(instance);
      instance.mount();
    });
  }
});

document.addEventListener( 'DOMContentLoaded', function() {
  // Splide for Team
  var splideSingle = document.querySelectorAll('.splide--slide-single');

  if (splideSingle) {
    splideSingle.forEach(function(splide) {
      var instance = new Splide(splide, {
        type: 'loop',
        perPage: 1,
        gap: '1.5rem',
        pagination: true,
        arrows: true,
      });
      watchPaginationOverflow(instance);
      instance.mount();
    });
  }
});

document.addEventListener( 'DOMContentLoaded', function() {
  // Splide for Treatments
  var splideTeam = document.querySelectorAll('.splide--treatments');

  if (splideTeam) {
    splideTeam.forEach(function(splide) {
      var slideCount = splide.querySelectorAll('.splide__slide').length;

      // Only loop when there are more treatments than the widest perPage —
      // 'loop' clones slides to fill perPage, which duplicates cards.
      var instance = new Splide(splide, {
        type: slideCount > 3 ? 'loop' : 'slide',
        perPage: 3,
        gap: '2rem',
        pagination: true,
        arrows: true,
        mediaQuery: 'max',
        breakpoints: {
          1024: {
            perPage: 2,
          },
          768: {
            perPage: 1,
          },
        },
      });
      watchPaginationOverflow(instance);
      instance.mount();
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const splides = document.querySelectorAll(
    '.splide--guides, .splide--case-studies'
  );

  splides.forEach(function (splide) {
    var slideCount = splide.querySelectorAll('.splide__slide').length;

    // Only loop when there are more slides than the widest perPage —
    // 'loop' clones slides to fill perPage, which duplicates cards.
    var instance = new Splide(splide, {
      type: slideCount > 2 ? 'loop' : 'slide',
      perPage: 2,
      gap: '2rem',
      pagination: true,
      arrows: true,
      mediaQuery: 'max',
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});



document.addEventListener( 'DOMContentLoaded', function() {
  // Splide for Cards
  var splideCards = document.querySelectorAll('.splide--cards');

  if (splideCards) {
    splideCards.forEach(function(splide) {
      var slideCount = splide.querySelectorAll('.splide__slide').length;

      // Cap perPage at the actual slide count so fewer cards than a tier's
      // perPage stretch to fill the row instead of leaving empty space.
      // Arrows/pagination are then hidden per-breakpoint via the
      // .is-overflow class Splide toggles when nothing is left to scroll to.
      var instance = new Splide(splide, {
        type: 'slide',
        perPage: Math.min(5, slideCount),
        gap: '1.5rem',
        pagination: true,
        arrows: true,
        mediaQuery: 'max',
        breakpoints: {
          1440: {
            perPage: Math.min(4, slideCount),
          },
          1120: {
            perPage: Math.min(3, slideCount),
          },
          1024: {
            perPage: Math.min(2, slideCount),
          },
          768: {
            perPage: 1,
          },
        },
      });
      watchPaginationOverflow(instance);
      instance.mount();
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Splide for Gallery
  const splideGallery = document.querySelectorAll('.splide--gallery');

  splideGallery.forEach(function (splideEl) {
    // Padding tiers roughly mirror .inner__wrapper's own breakpoints
    // (1024 / 1536), as flat values per tier rather than a pixel-exact
    // continuous match. Above 1536px, .inner__wrapper has 0 side padding
    // and caps at max-width: 1440px (see _base.scss / $site-width), so its
    // content edge sits at (100vw - 1440px) / 2 — matched here exactly
    // instead of with a flat percentage, which drifts out of alignment
    // above/below the one viewport width (1920px) where 12.5% happens to
    // coincide with that formula.
    var instance = new Splide(splideEl, {
      type: 'loop',
      padding: 'calc((100% - 1440px) / 2)',
      gap: '2rem',
      perPage: 1,
      pagination: true,
      arrows: true,
      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
      mediaQuery: 'max',
      breakpoints: {
        1536: {
          padding: '4rem',
          gap: '1rem',
        },
        1024: {
          padding: '1em',
          gap: '0.5rem',
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Splide for Info Cards
  const splideInfoCards = document.querySelectorAll('.splide--info-cards');

  splideInfoCards.forEach(function (splide) {
    var slideCount = splide.querySelectorAll('.splide__slide').length;

    // Cap perPage at the actual slide count so fewer cards than a tier's
    // perPage stretch to fill the row instead of leaving empty space.
    var instance = new Splide(splide, {
      type: 'slide',
      perPage: Math.min(4, slideCount),
      gap: '2rem',
      pagination: true,
      arrows: true,
      mediaQuery: 'max',
      breakpoints: {
        1120: {
          perPage: Math.min(3, slideCount),
        },
        768: {
          perPage: Math.min(2, slideCount),
        },
        480: {
          perPage: 1,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Splide for Sports Massage Rates
  const splidePricingCards = document.querySelectorAll('.splide--sports-massage-rates');

  splidePricingCards.forEach(function (splide) {
    var slideCount = splide.querySelectorAll('.splide__slide').length;

    // Full desktop width uses a fixed 336px card width (the size 4 cards
    // work out to inside the 1440px container at gap: 2rem) instead of
    // perPage-based stretch sizing, so 3 cards render at the same width as
    // 4 rather than stretching to fill the row. fixedWidth auto-computes
    // how many are visible, so no slideCount capping is needed at this tier.
    // .inner__wrapper only reaches its full 1440px (0 side padding) at
    // 1536px viewport width (see _base.scss) — below that its content area
    // is narrower than 1440px, so the 1536 breakpoint reverts to the
    // original perPage-based stretch-to-fill sizing, capped at the actual
    // slide count so fewer cards than a tier's perPage don't stretch to
    // fill the row. fixedWidth must be explicitly cleared per breakpoint or
    // Splide keeps inheriting it from the base config.
    // Arrows/pagination are then hidden per-breakpoint via the
    // .is-overflow class Splide toggles when nothing is left to scroll to.
    var instance = new Splide(splide, {
      type: 'slide',
      fixedWidth: '336px',
      gap: '2rem',
      pagination: true,
      arrows: true,
      mediaQuery: 'max',
      breakpoints: {
        1536: {
          fixedWidth: false,
          perPage: Math.min(4, slideCount),
        },
        1120: {
          fixedWidth: false,
          perPage: Math.min(3, slideCount),
        },
        768: {
          fixedWidth: false,
          perPage: Math.min(2, slideCount),
        },
        480: {
          fixedWidth: false,
          perPage: 1,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Splide for Membership Rates
  const splideMembershipRates = document.querySelectorAll('.splide--membership-rates');

  splideMembershipRates.forEach(function (splide) {
    var slideCount = splide.querySelectorAll('.splide__slide').length;

    // Cap perPage at the actual slide count so 3 or fewer cards render as a
    // centered row instead of stretching/sliding. Above 3 cards it becomes a
    // slider, dropping to 2 per row on tablet and 1 on mobile.
    var instance = new Splide(splide, {
      type: 'slide',
      perPage: Math.min(3, slideCount),
      gap: '2rem',
      pagination: true,
      arrows: true,
      mediaQuery: 'max',
      breakpoints: {
        1024: {
          perPage: Math.min(2, slideCount),
        },
        768: {
          perPage: 1,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Splide for Location Cards
  const splideLocationCards = document.querySelectorAll('.splide--location-cards');

  splideLocationCards.forEach(function (splide) {
    var slideCount = splide.querySelectorAll('.splide__slide').length;

    // perPage stays fixed to the tier sizes so a card always renders at its
    // normal "1 of 4/3/2" width instead of stretching to fill the row.
    // Arrows/pagination are hidden per-breakpoint via the .is-overflow
    // class Splide toggles when nothing is left to scroll to.
    var instance = new Splide(splide, {
      type: slideCount > 4 ? 'loop' : 'slide',
      perPage: 4,
      gap: '2rem',
      pagination: true,
      arrows: true,
      mediaQuery: 'max',
      breakpoints: {
        1120: {
          perPage: 3,
        },
        1024: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Splide for Display Events
  const splideDisplayEvents = document.querySelectorAll('.splide--display-events');

  splideDisplayEvents.forEach(function (splide) {
    var slideCount = splide.querySelectorAll('.splide__slide').length;

    // Cap perPage at the actual slide count so 3 or fewer cards render as a
    // static row instead of an active slider. Above 3 cards it becomes a
    // slider, dropping to 2 per view on tablet and 1 on mobile — arrows and
    // pagination are hidden per-breakpoint via the .is-overflow class Splide
    // toggles when nothing is left to scroll to.
    var instance = new Splide(splide, {
      type: 'slide',
      perPage: Math.min(3, slideCount),
      gap: '2rem',
      pagination: true,
      arrows: true,
      mediaQuery: 'max',
      breakpoints: {
        1024: {
          perPage: Math.min(2, slideCount),
        },
        768: {
          perPage: 1,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const highlightSliders = document.querySelectorAll('.splide--highlights');

  highlightSliders.forEach(function (slider) {
    var instance = new Splide(slider, {
      mediaQuery: 'min',
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '1.5rem',
      pagination: true,
      arrows: true,

      breakpoints: {
        768: {
          destroy: true,
        },
      },
    });
    watchPaginationOverflow(instance);
    instance.mount();
  });
});